import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react';
import { clsx } from 'clsx';
import { ChevronDown, CircleAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { MemberFragment } from '../GroupListing/GroupList.api';
import MemberCard from './MemberCard';
import type { UserRole } from '@/apolloClient.types';

interface UnassignedMembersSectionProps {
    members: MemberFragment[];
    getRoleLabel: (role: UserRole) => string;
}

const UnassignedMembersSection = ({ members, getRoleLabel }: UnassignedMembersSectionProps) => {
    const { t } = useTranslation('groups');

    if (members.length === 0) {
        return null;
    }

    return (
        <Disclosure defaultOpen={false}>
            {({ open }) => (
                <>
                    {/* Unassigned Members Header */}
                    <DisclosureButton className="flex w-full items-center justify-between gap-2.5 border-t-[1px] border-neutral-300 bg-orange-50 p-5 text-left hover:bg-orange-100">
                        <div className="flex flex-1 items-center gap-2.5">
                            <CircleAlert className="size-4 flex-shrink-0 text-orange-500" />
                            <div className="flex-1 leading-6 font-bold text-neutral-900">
                                {t('viewMembersModal.unassignedMembers', 'Unassigned Members')}
                            </div>
                        </div>
                        <ChevronDown
                            className={clsx('size-4 text-neutral-800 transition-transform', open && 'rotate-180')}
                        />
                    </DisclosureButton>

                    {/* Unassigned Members */}
                    <DisclosurePanel>
                        {members.map((member, index) => (
                            <MemberCard
                                key={member.id}
                                member={member}
                                getRoleLabel={getRoleLabel}
                                isLast={index === members.length - 1}
                            />
                        ))}
                    </DisclosurePanel>
                </>
            )}
        </Disclosure>
    );
};

export default UnassignedMembersSection;
